import { API } from '../api';
import axiosInstance from '../axiosConfig';

export const addAdmin = async (body) => {
  const response = await axiosInstance.post(API.ADMIN.ADD_ADMIN, body);
  return response;
};
export const updateAdmin = async (body) => {
  const response = await axiosInstance.patch(API.ADMIN.UPDATE_ADMIN, body);
  return response;
};
export const getAdmins = async (id) => {
  const response = await axiosInstance.get(API.ADMIN.GET_ALL_ADMIN + id);
  return response;
};
export const getPlatformAndSuperAdmins = async () => {
  const response = await axiosInstance.get(API.ADMIN.GET_PLATFORM_AND_SUPER_ADMINS );
  return response;
};
export const deleteAdmin = async (id) => {
  const response = await axiosInstance.delete(API.ADMIN.DELETE_ADMIN + id);
  return response;
};
// export const updateService = async (body) => {
//   console.log(body);
//   const response = await axiosInstance.patch(API.SERVICES.UPDATE_SERVICE, body);
//   return response;
// };
export const freezeAdmin = async (id, status) => {
  const response = await axiosInstance.get(API.ADMIN.FREEZE_ADMIN + id + '/' + status);
  return response;
};

export const resetUser = async (email) => {
  const response = await axiosInstance.get(API.ADMIN.RESET_ADMIN + email);
  return response;
};
export const updateAdminEmail = async (body) => {
  const response = await axiosInstance.post(API.ADMIN.UPDATE_EMAIL, body);
  return response;
};

export const verifyEmailRequest = async (body) => {
  const response = await axiosInstance.post(API.ADMIN.VERIFY_EMAIL_REQUEST, body);
  return response;
};

export const resendInvitation = async (body) => {
  const response = await axiosInstance.post(API.ADMIN.RESEND_INVITATION, body);
  return response;
};
